import { useCallback, useRef } from 'react';
import { CONFIRM_GUARD_MS } from '../components/shared/CancelTaskConfirm';

/**
 * The 400 ms quick-action guard of the Task Board (P-TASK-053), shared with
 * the unit Activity tab (D11). Start, Complete and Reopen move the task (on
 * the board the card leaves its column), so the second click of a double-click
 * would land on whatever slid under the pointer. The returned function says
 * whether a click may act: never the second click of a double-click
 * (event.detail > 1), and never within `ms` of the previous accepted one —
 * across the whole board or tab, not per button.
 */
export default function useQuickGuard(ms = CONFIRM_GUARD_MS) {
    const lastAt = useRef(0);
    return useCallback((e) => {
        if (e && e.detail > 1) return false;
        const t = Date.now();
        if (t - lastAt.current < ms) return false;
        lastAt.current = t;
        return true;
    }, [ms]);
}
